export const TOOGLE_AGREEMENT_FIELD_DATA = 'ProductDetails::OutOfStock::AgreementField';

export const OUT_OF_STOCK_FORM_ERROR = 'ProductDetails::OutOfStock::StateError';
export const OUT_OF_STOCK_FORM_SUCCESS = 'ProductDetails::OutOfStock::StateSuccess';
export const OUT_OF_STOCK_FORM_FIELD_AGREEMENT = 'ProductDetails::OutOfStock::AgreementField';
export const OUT_OF_STOCK_FORM_NAME = 'ProductDetails::OutOfStock::FormName';
export const SUBSCRIBED_TO_PRODUCT = 'ProductDetails::OutOfStock::Subscribe';

export const ERROR_CLASSNAME = 'error';
export const INFO_CLASSNAME = 'info';
export const UP_EMOJI = 'up';
export const STATUS_FAIL_EMOJI = 'statusFail';

export const LOCAL_STORAGE_DATA_KEY = 'outofstockProductIds';
